import WebFont from 'webfontloader';

import BlogRecommended from './components/BlogRecommended';
import BlogOverview from './components/BlogOverview';
import MobileMenu from './components/MobileMenu';
import Packages from './components/Packages';
import Contact from './components/Contact';
import Header from './components/Header';
import Hero from './components/Hero';
import Video from './components/Video';
import Page from './Page';
import Faq from './components/Faq';

WebFont.load({
  custom: {
    families: ['BR Hendrix']
  },
  active: () => {
    const page = new Page();

    page.addComponent(new Header());
    page.addComponent(new MobileMenu());

    if (document.querySelector('.possibilities__video')) {
      page.addComponent(new Video());
    }

    if (document.querySelector('.contact')) {
      page.addComponent(new Contact());
    }

    if (document.querySelector('.blog__cards.is-overview')) {
      page.addComponent(new BlogOverview());
    }

    if (document.querySelector('.blog__recommended')) {
      page.addComponent(new BlogRecommended());
    }

    if (document.querySelector('.faq')) {
      page.addComponent(new Faq());
    }

    if (document.querySelector('.packages')) {
      page.addComponent(new Packages());
    }

    if (document.querySelector('.hero')) {
      page.addComponent(new Hero());
    }
  },
});
